<template>
    <div>
        <div class="modal right" tabindex="-1" role="dialog" id="exampleModalLong">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">{{$t('Create Placeholder')}}</h6>
                        <button
                            class="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-on:click="closeDialog()"
                            title="Close"
                            >
                            <span aria-hidden="true">
                                <cancel-icon tabindex="0" class="close-icon categorybrowse" style="height: 30px !important;
                                    width: 30px !important;
                                    color: #fff;">
                                </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                            <div>
                                <label>{{$t('File format/extension')}} <span style="font-size: 15px">*</span></label>
                            </div>
                            <input v-model="extension" type="text" placeholder="Ex: mp4" class="bg-transparent rounded text-light input-text-field add-border"/>
                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style">
                        <button class="btn btn-outline-secondary ml-1" title="Close" @click="closeDialog()">{{$t('Cancel')}}</button>
                        <button @click="createPlaceholderPost()" class="btn btn-outline-primary ml-1">{{$t('Save')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import cancelIcon from "../core/InlineCancelField.vue";
import {mapActions} from "vuex";
import Utils from "../../components.utils.js"

export default {
    props:['fileInfo'],
    data: () => ({
        dialog: true,
        commentText:"",
        selectedFileInfo:null,
        extension:""
    }),
    components: {
        'cancel-icon':cancelIcon,
    },
    methods:{
        closeDialog(){
            this.$emit("close")
        },
        createPlaceholderPost(){
            let payload = {
                'extention':this.extension,
                'asset_id':this.fileInfo.asset_id
            }
            this.createPlaceholder(payload).then(data => {
                if (Utils.isAcceptedStatusCode(data.statusCode)){
                    this.closeDialog();
                    this.$toast.success(data.message);
                }else{
                    this.$toast.error(data.message);
                }
            })
        },
        ...mapActions("versions", ["createPlaceholder"]),
    },
}
</script>

<style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $icon-hover:#2c3339;

.modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }

  .modal{
    transition: opacity .3s ease;
  }

  
  .modal-content {
    height: 255px;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 10px;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 20%;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:$input-field-and-label-font-size !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    align-items: center;
    .modal-title{
      color:$text-color;
    }
}

.primary-btn-style{
    button{
        height: 35px;
        font-size:$input-field-and-label-font-size;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 16%;
  font-size: $input-field-and-label-font-size;
  margin-top: 11px;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.common-input-field{
    margin-inline-start: 3%;
    display: inline-block;
    width: 96%;
    justify-content: space-between;
    display: inline-block;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    border: $secondary-border-color !important;
    label{
        width: 30%;
        color: $secondary-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}

.input-text-field{
    height: 44px;
    width: 100% !important;
    padding-inline-start: 2%;
    padding-inline-end:2%;
    overflow: hidden;
}

.add-border{
    border: $border-color;
}

::placeholder{
  font-size: 14px!important;
  font-family: Roboto,Arial,sans-serif!important;
  color: #525252 !important;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
}
</style>